export default "__VITE_ASSET__Dnr7r5ZO__"